var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
export var StyledTable = styled.table(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n  border-collapse: collapse;\n"], ["\n  width: 100%;\n  height: 100%;\n  border-collapse: collapse;\n"])));
export var BlockLayout = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: inline-block;\n  border-spacing: 0;\n"], ["\n  display: inline-block;\n  border-spacing: 0;\n"])));
var templateObject_1, templateObject_2;
